export default __webpack_public_path__ + "static/media/A_lopetus2.5140e655.mp3";